var _excluded = ["src", "srcSet", "sizes", "base", "alt", "width", "height"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { toCssSize } from '../../utils';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Image/Image');
var ratios = {
  '1 / 1': '100',
  '1/1': '100',
  '3 / 4': '133.3333',
  '3/4': '133.3333',
  '4 / 3': '75',
  '4/3': '75',
  '9 / 16': '177.7778',
  '9/16': '177.7778',
  '16 / 9': '56.25',
  '16/9': '56.25',
  '1 / 2': '200',
  '1/2': '200',
  '2 / 1': '50',
  '2/1': '50'
};
var StyledRoot = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-3h0amr-0"
})(["position:relative;display:block;box-sizing:border-box;overflow:hidden;width:100%;height:inherit;border-radius:inherit;", " ", ""], function (_ref) {
  var $ratio = _ref.$ratio,
      $customRatio = _ref.$customRatio;
  return ($ratio || $customRatio) && css(["height:0;padding-bottom:", "%;"], $ratio ? ratios[$ratio] : $customRatio);
}, function (_ref2) {
  var $width = _ref2.$width,
      $height = _ref2.$height;
  return css(["", " ", ""], $width && "width: ".concat(toCssSize($width), ";"), $height && "height: ".concat(toCssSize($height), ";"));
});
var StyledImg = /*#__PURE__*/styled.img.withConfig({
  componentId: "plasma__sc-3h0amr-1"
})(["width:100%;", ";"], function (_ref3) {
  var src = _ref3.src,
      ratio = _ref3.ratio;
  return src && ratio && css(["height:100%;object-fit:cover;position:absolute;"]);
});
var StyledDivImg = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-3h0amr-2"
})(["width:100%;height:100%;position:absolute;background-position:center;background-size:cover;"]);
/**
 * Компонент для отображения картинок.
 */

var ImageBase = function ImageBase(_ref4) {
  var src = _ref4.src,
      srcSet = _ref4.srcSet,
      sizes = _ref4.sizes,
      _ref4$base = _ref4.base,
      base = _ref4$base === void 0 ? 'img' : _ref4$base,
      alt = _ref4.alt,
      width = _ref4.width,
      height = _ref4.height,
      props = _objectWithoutProperties(_ref4, _excluded);

  var ratio = 'ratio' in props ? props.ratio : undefined;
  var customRatio = 'customRatio' in props ? props.customRatio : undefined;
  return /*#__PURE__*/React.createElement(StyledRoot, _extends({
    $ratio: ratio,
    $customRatio: customRatio,
    $width: width,
    $height: height
  }, props), base === 'img' && /*#__PURE__*/React.createElement(StyledImg, {
    src: src,
    srcSet: srcSet,
    sizes: sizes,
    alt: alt,
    ratio: ratio
  }), base === 'div' && /*#__PURE__*/React.createElement(StyledDivImg, {
    style: {
      backgroundImage: "url(".concat(src, ")")
    },
    role: "img",
    "aria-label": alt
  }));
};
/**
 * Компонент для отображения картинок.
 */


export var Image = /*#__PURE__*/styled(ImageBase).withConfig({
  componentId: "plasma__sc-3h0amr-3"
})([""]);